import axios from "axios";
import { errorResponse } from "src/store/common";
import { alertMessages, mutateReportQuery, deleteReportQuery, getReportsQuery} from "src/constants";
import { configMutationClimatology } from "./mutationsApiKey";

export const createUpdateReport = async (params: any, addAlert: any) => {
    try {
        let data = JSON.stringify({
            query: mutateReportQuery,
            variables: {
                id: params.id,
                title: params.title,
                description: params.description,
                type: params.type,
                url: params.url,
                visible: params.visible
            }
        });
        let config = configMutationClimatology(data, null);
        return (
            new Promise(function (resolve, reject) {
                axios(config)
                    .then(async function (response: any) {
                        if (response?.data.errors) {
                            return reject(new Error(response.data.errors[0].message))
                        }
                        else {
                            return resolve(response)

                        }
                    })
                    .catch(function (error: any) {
                        console.log('error', error);
                        return reject(new Error(error))
                    });
            })
        )
    }
    catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.report);

    }
};

export const deleteReport = async (params: any, addAlert: any) => {
    try {
        let data = JSON.stringify({
            query: deleteReportQuery,
            variables: {
                id: params.id
            }
        });
        let config = configMutationClimatology(data, null);
        return (
            new Promise(function (resolve, reject) {
                axios(config)
                    .then(async function (response: any) {
                        if (response?.data.errors) {
                            return reject(new Error(response.data.errors[0].message))
                        }
                        else {
                            return resolve(response.data.data.deletePowerBIReport)

                        }
                    })
                    .catch(function (error: any) {
                        console.log('error', error);
                        return reject(new Error(error))
                    });
            })
        )
    }
    catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.report);

    }
};


export const getReports = async (params: any, addAlert: any) => {
    try {
        let data = JSON.stringify({
            query: getReportsQuery,
            variables: {
                sortBy: params.sortBy,
                sortOrder: params.sortOrder,
                page: params.page,
                perPage: params.perPage,
                type: params.type,
                id:params.id,
                visible: params.visible
            }
        });
        let config = configMutationClimatology(data, null);
        return (
            new Promise(function (resolve, reject) {
                axios(config)
                    .then(async function (response: any) {
                        if (response?.data.errors) {
                            return reject(new Error(response.data.errors[0].message))
                        }
                        else {
                            return resolve(response.data.data.getPowerBIReports.data)

                        }
                    })
                    .catch(function (error: any) {
                        console.log('error----', error);
                        //return reject(new Error(error))
                    });
            })
        )
    }
    catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.report);

    }
};
